import React from 'react';
import { CssBaseline, withStyles } from '@material-ui/core';

import Topbar from '../../common/Topbar';
import Footer from '../../common/Footer';

const styles = (theme) => ({
  root: {
    width: '100%',
    position: 'relative',
  },
});

class Container extends React.Component {
  componentDidMount() {
    window.addEventListener('resize', this.handleEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleEvent);
  }

  handleEvent = () => {
    // console.log('창크기바뀜');
    // console.log('너비: ', window.innerWidth);
    // console.log('높이: ', window.innerHeight);
    document.getElementById('main_container').style.height = `calc(${window.innerHeight}px - 135px)`;
  };

  render() {
    const { classes, children, currentPath } = this.props;

    return (
      <div>
        <CssBaseline />

        <Topbar currentPath={currentPath} />
        <div
          id="main_container"
          className={classes.root}
          style={
            // currentPath.indexOf('/about') > -1 ? { height: 'calc(100vh - 135px)' } :
            { height: `calc(${window.innerHeight}px - 135px)` }
          }
          // style={{ height: 'calc(100vh - 135px)' }}
        >
          {children}
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles)(Container);
